module.exports = __webpack_public_path__ + "img/ic_target income_yellow.090d33ec.svg";